import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footerMain}>
            <div className={styles.footerTop}>
                <div className="container">
                    <div className="row gy-4">

                        {/* Brand Column */}
                        <div className="col-lg-4 col-md-6">
                            <div className={styles.brandBox}>
                                <img src="/images/logo/logo_mini1.png"  alt="Cyber Soft Dev Logo" style={{width:"200px"}} />
                                <p className={styles.brandText}>
                                    Architecting digital success through precision engineering and creative innovation. 
                                    We transform complex challenges into seamless user experiences.
                                </p>
                                <div className={styles.socialGrid}>
                                    <a href="https://www.facebook.com/people/Cyber-Software-Developers/61577848002180" target='_blank' aria-label="Facebook" className={styles.socialIcon}><i className="fab fa-facebook-f"></i></a>
                                    <a href="https://youtube.com/@cybersoftwaredevelopers" aria-label="Youtube" target='_blank' className={styles.socialIcon}><i className="fab fa-youtube"></i></a>
                                    <a href="https://www.instagram.com/cybersoftdev/" aria-label="Instagram" target='_blank' className={styles.socialIcon}><i className="fab fa-instagram"></i></a>
                                    <a href="https://www.linkedin.com/company/cyber-software-developers/" target='_blank' aria-label="LinkedIn" className={styles.socialIcon}><i className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                        </div>

                        {/* Navigation Column */}
                        <div className="col-lg-2 col-md-6">
                            <h5 className={styles.columnTitle}>Company</h5>
                            <ul className={styles.linkList}>
                                <li><a href="#about">About Our Vision</a></li>
                                <li><a href="#services">Our Ecosystem</a></li>
                                <li><a href="#projects">Portfolio</a></li>
                                <li><a href="#careers">Join the Team</a></li>
                            </ul>
                        </div>

                        {/* Services Column */}
                        <div className="col-lg-3 col-md-6">
                            <h5 className={styles.columnTitle}>Core Services</h5>
                            <ul className={styles.linkList}>
                                <li><a href="#">Enterprise Web Apps</a></li>
                                <li><a href="#">Mobile Innovation</a></li>
                                <li><a href="#">AI & Automation</a></li>
                                <li><a href="#">Cloud Architecture</a></li>
                            </ul>
                        </div>

                        {/* Contact Column */}
                        <div className="col-lg-3 col-md-6">
                            <h5 className={styles.columnTitle}>Get In Touch</h5>
                            <div className={styles.contactInfo}>
                                <a href="mailto:info@cybersoftdev.com" className={styles.contactLink}>
                                    <i className="bi bi-envelope-at"></i> info@cybersoftdev.com
                                </a>
                                <a href="tel:+918421367454" className={styles.contactLink}>
                                    <i className="bi bi-telephone-outbound"></i> +91 84213 67454
                                </a>
                                <p className={styles.locationText}>
                                    <i className="bi bi-geo-alt"></i> Vijaynagar, Maharashtra, India
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className={styles.footerBottom}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center text-md-start">
                            <p className={styles.copyrightText}>
                                © {currentYear} <span className={styles.highlight}>Cyber Software Developers</span>. All Rights Reserved.
                            </p>
                        </div>
                        <div className="col-md-6 text-center text-md-end">
                            <div className={styles.legalLinks}>
                                <a href="#">Privacy Policy</a>
                                <a href="#">Terms of Service</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;